module.exports = __webpack_public_path__ + "static/media/exterior.57b283e4.jpg";